import { Directive, HostBinding, Host, ElementRef, HostListener } from '@angular/core';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[horizontalScroll]',
  standalone: false,
  host: {
    '(wheel)': 'wheelTurned($event)',
    '[scrollLeft]': 'scrollLeft'
  }
})
export class HorizontalScrollDirective {

  private nativeElement: HTMLElement;
  scrollLeft: number;

  constructor(@Host() element: ElementRef) {
    this.nativeElement = element.nativeElement;
  }

  @HostListener('wheel', ['$event']) wheelTurned(wheelEvent: WheelEvent) {
    if (wheelEvent.deltaY) {
      this.scrollLeft = this.nativeElement.scrollLeft + wheelEvent.deltaY;
      wheelEvent.preventDefault();
    }
  }
}
